import { render, staticRenderFns } from "./homes.vue?vue&type=template&id=08c2a1de&scoped=true"
import script from "./homes.vue?vue&type=script&lang=js"
export * from "./homes.vue?vue&type=script&lang=js"
import style0 from "./homes.vue?vue&type=style&index=0&id=08c2a1de&lang=scss&scoped=true"
import style1 from "./homes.vue?vue&type=style&index=1&id=08c2a1de&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2a1de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c2a1de')) {
      api.createRecord('08c2a1de', component.options)
    } else {
      api.reload('08c2a1de', component.options)
    }
    module.hot.accept("./homes.vue?vue&type=template&id=08c2a1de&scoped=true", function () {
      api.rerender('08c2a1de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/homes.vue"
export default component.exports